import $ from 'jquery';
import AjaxRequest from "../modules/ajax-request";

class Ranking {
    constructor(element) {
        this.div = element;
        this.url = "";

        this.getData();
        this.clearData();
        this.init();
    }
    getData() {
        this.url = $(this.div).data("url");
    }
    clearData() {
        $(this.div).removeAttr("data-url");
    }
    init() {
        let _div = this.div;
        let ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $(_div).replaceWith(response.message);
            }
        });
        ajaxRequest.makeCall(this.url);
    }
}

export default Ranking
